// Rounds the value to nearest step and clamps between min and max to prevent floating point errors
export const roundToStep = (
  value: number,
  step: number,
  min = 0,
  max = Infinity,
) => {
  const roundedNumber = Math.round(value / step) * step;
  return Math.min(max, Math.max(min, Number(roundedNumber.toFixed(3))));
};
